export const iconFontAwesomeShoppingApplePay = (
	<i className="fa-solid fa-apple-pay"></i>
);
